export const GET_CATEGORIES_ACTION = "uniform/getCategories";
export const CREATE_CATEGORY_ACTION = "uniform/createCategory";
export const UPDATE_CATEGORY_ACTION = "uniform/updateCategory";
export const REMOVE_CATEGORY_ACTION = "uniform/removeCategory";
export const GET_TYPE_ACTION = "uniform/getType";
export const CREATE_TYPE_ACTION = "uniform/createType";
export const UPDATE_TYPE_ACTION = "uniform/updateType";
export const REMOVE_TYPE_ACTION = "uniform/removeType";
export const ARCHIVE_OPERATION_ACTION = "uniform/archiveOperation";
